import z from 'zod';
import { createRoute } from '../functions/createRoute';
export const OrganizationRootRoute = createRoute('orga-root', {
    path: '/organization',
    schema: z.object({}),
    exact: false,
});
